import styles from './ContactCompleted.module.scss'
import Column from 'components/home/Column'
import BottomSlider from 'components/commons/BottomSlider/BottomSlider'
import { useRouter } from 'next/router'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const ContactCompleted: React.FC = () => {
  const router = useRouter()
  let buttonText
  if (router.pathname === '/lp-ui-contact-completed') {
    buttonText = 'コーポレートサイトへ'
  } else {
    buttonText = 'トップページへ戻る'
  }

  return (
    <article className={styles.main}>
      <section className={styles.content}>
        <div className={styles.inner}>
          <div className={styles.title_group}>
            <div className={styles.text_container}>
              <h1 className={styles.title}>
                お問い合わせいただき
                <br className={styles.is_sp} />
                ありがとうございます。
              </h1>
              <p className={styles.firsttext}>
                コンサルタントからご連絡を差し上げます。
                <br />
                お問い合わせ内容によってはお時間をいただく場合もございますので、予めご了承ください。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.section}>
        <BottomSlider />
      </section>
      <MailmagazineLink white noGsap />
      <div className={styles.column}>
        <Column tagType="h2" />
      </div>
    </article>
  )
}

export default ContactCompleted
